module.exports = __webpack_public_path__ + "img/102.c906f987.svg";